import MicromodalEs from "micromodal";
import Toastify from "toastify-js/src/toastify";
import {userLogin} from "./user-login";

const Pristine = require('pristinejs')

export function openModal() {

    document.addEventListener('click', (e) => {

        if (!(e.target && e.target.classList.contains('modal__btn--open'))) {
            return;
        }

        e.preventDefault();

        MicromodalEs.show('modal', {
            disableScroll: true,
            closeTrigger: 'data-modal-close-trigger',
            onShow: (modal) => {
                switch (e.target.dataset.action) {
                    case 'video':
                        showVideoModal(modal, e.target);
                        break;
                    case 'login':
                        showLoginModal(modal, e.target);
                        break;
                    case 'share':
                        showShareModal(modal, e.target)
                        break;
                    case 'public-share':
                        showSharePublicModal(modal, e.target)
                        break;
                    case 'delete-user':
                        deleteUser(modal, e.target)
                        break;
                }
            },
            onClose: (modal) => {
                modal.querySelector('.modal__container').setAttribute('class', 'modal__container')
                modal.querySelector('.modal__content').innerHTML = '';
            }

        })

    })
}

export function clickModal() {
    document.addEventListener('click', (e) => {
        if ((e.target && e.target.classList.contains('btn-facebook'))) {

            FB.init({
                appId: share_object.fb_api,
                autoLogAppEvents: true,
                xfbml: true,
                version: 'v14.0'
            })

            FB.ui({
                method: 'share',
                href: e.target.dataset.url || window.location.href,
            }, function (response) {
            });
        }

        if ((e.target && e.target.classList.contains('btn-linkedin'))) {
            let script = document.createElement("script")
            script.type = "IN/Share";
            script.dataset.url = e.target.dataset.url || window.location.href;

            document.querySelector('.modal__container .modal__content').appendChild(script)
            IN.parse();

            document.querySelector('.IN-widget button').click();
        }

        if ((e.target && e.target.classList.contains('btn-copy'))) {
            let url = e.target.dataset.url || window.location.href;
            console.log(url)
            navigator.clipboard.writeText(url).then(() => {
                /* clipboard successfully set */
                console.log('link has been copied')
            }, () => {
                /* clipboard write failed */
                console.log('fail')
            });

            Toastify({
                text: "Linket er blevet kopieret",
                duration: 3000,
                close: false,
                gravity: "top", // `top` or `bottom`
                position: "right", // `left`, `center` or `right`
                stopOnFocus: true, // Prevents dismissing of toast on hover
            }).showToast();

        }
    })
}

function showVideoModal(modal, el) {
    let video_url = el.dataset.videoUrl,
        video_poster = el.dataset.videoPoster;

    modal.querySelector('.modal__container').classList.add('modal__container--video')
    modal.querySelector('.modal__content').innerHTML = `<video width="100%" height="100%" controls poster="${video_poster}"><source src="${video_url}" type="video/mp4"></video>`
}

function showLoginModal(modal, el) {
    modal.querySelector('.modal__container').classList.add('modal__container--login')
    modal.querySelector('.modal__content').innerHTML = `
    <header>
        <h2>Login</h2>
    </header>
    <div class="form__container login">
    <form class="js-login">
        <div class="input__container form-group full">
            <input type="email" name="email" class="form-control" id="login_modal_email" required
                   data-pristine-email-message="Dette felt skal være en email"
                   data-pristine-required-message="Dette felt skal udfyldes">
            <label for="login_modal_email">E-mail</label>
        </div>
        <div class="input__container form-group full">
            <input type="password" name="pwd" class="form-control" id="login_modal_pwd" required data-pristine-type="text"
                   data-pristine-required-message="Dette felt skal udfyldes">
            <label for="login_modal_pwd">Adgangskode</label>
        </div>
        <div class="input__container full error_message">
        </div>
        <div class="input__container full">
            <input type="hidden" name="redirect_to" value="${window.location.href}">
            <button class="button btn-full btn-background btn-primary btn-icon btn-animated btn-arrow">Login</button>
        </div>  
        <div class="input__container full">
            <p><a href="${ajax_object.lost_pwd}" class="lost-pwd">Mistet din adgangskode</a> eller <a href="" class="create-user">Opret bruger</a></p>
        </div>
    </form>
    </div>
    `

    let pristine = new Pristine(document.querySelector('.js-login'), null, false)

    document.addEventListener('submit', (e) => {
        let element = e.target;

        if (element && e.target.classList.contains('js-login')) {
            e.preventDefault();

            if (!pristine.validate()) {
                return;
            }

            let formData = new FormData(e.target);

            formData.append('action', 'user_login');
            formData.append('_wpnonce', ajax_object.wp_nonce)

            userLogin(formData, e.target)
        }
    })
}

function showShareModal(modal, el) {
    let content = modal.querySelector('.modal__content')

    modal.querySelector('.modal__container').classList.add('modal__container--share')
    content.innerHTML = `<header><h2>Del siden med dine venner!</h2></header><div class="buttons__container"></div>`

    if (ajax_object.sharing.facebook) {
        content.querySelector('.buttons__container').innerHTML += `<button type="button" class="button btn-full btn-background btn-icon-before btn-facebook">Facebook</button>`
    }

    if (ajax_object.sharing.linkedin) {
        content.querySelector('.buttons__container').innerHTML += `<button type="button" class="button btn-full btn-background btn-icon-before btn-linkedin">Linkedin</button>`
    }

    if (ajax_object.sharing.email) {
        content.querySelector('.buttons__container').innerHTML += `<a href="mailto:?subject=${el.dataset.title}&body=${el.dataset.title} - ${window.location.href}" class="button btn-full btn-background btn-tertiary">Email</a>`
    }
}

function showSharePublicModal(modal, el) {
    let content = modal.querySelector('.modal__content')

    modal.querySelector('.modal__container').classList.add('modal__container--share')
    content.innerHTML = `<header><h2>Del dine gemte fag</h2></header><div class="buttons__container"></div>`

    if (ajax_object.sharing.facebook) {
        content.querySelector('.buttons__container').innerHTML += `<button type="button" class="button btn-full btn-background btn-icon-before btn-facebook" data-url="${el.dataset.url}">Facebook</button>`
    }

    if (ajax_object.sharing.linkedin) {
        content.querySelector('.buttons__container').innerHTML += `<button type="button" class="button btn-full btn-background btn-icon-before btn-linkedin" data-url="${el.dataset.url}">Linkedin</button>`
    }

    if (ajax_object.sharing.email) {
        content.querySelector('.buttons__container').innerHTML += `<a href="mailto:?subject=Mine gemte &body=${el.dataset.url}" class="button btn-full btn-background btn-tertiary">Email</a>`
    }

    content.querySelector('.buttons__container').innerHTML += `<button type="button"class="button btn-full btn-background btn-tertiary btn-copy" data-url="${el.dataset.url}">Kopier link</button>`

}

function deleteUser(modal, el) {
    let content = modal.querySelector('.modal__content')

    modal.querySelector('.modal__container').classList.add('modal__container--share')
    content.innerHTML = `
        <header>
            <h2>Slet din bruger</h2>
        </header>
        <div class="buttons__container">
        <form class="js-delete-user">
        <div class="input__container form-group full">
            <input type="password" name="pwd" class="form-control" id="pwd" required data-pristine-type="text"
                   data-pristine-required-message="Dette felt skal udfyldes">
            <label for="pwd">Adgangskode</label>
        </div>
        <div class="input__container full">
            <p><a href="${ajax_object.lost_pwd}" class="lost-pwd">Mistet din adgangskode</a> eller <a href="" class="create-user">Opret bruger</a></p>
        </div>
</form> 
</div>`

}
